'use strict';

const Errors = require('@nuorder/errors');

const createEnum = (obj) => {
    const dict = {};
    Object.keys(obj).forEach(key => {
        dict[obj[key]] = parseInt(key, 10);
    });
    return dict;
};

const ACCOUNT_STATUSES = {
    0: 'Active',
    1: 'HoldAllFunding',
    2: 'Canceled',
    3: 'WaitingForFirstTrans',
    4: 'WaitingForFirstAuth',
    99: 'Deleted',
};

const CARD_TYPES = {
    0: 'Uknown',
    1: 'ConsumerCredit',
    2: 'ConsumerDebit',
    3: 'ConsumerPrepaid',
    4: 'CommericalCredit',
    5: 'CommericalDebit',
    6: 'CommericalPrepaid',
    7: 'PurchasingCards',
    8: 'ACH',
};

const CARD_PRESENT_TYPES = {
    0: 'Unknown',
    1: 'CardPresent',
    2: 'CardNotPresent',
    3: 'ManualEntry',
    4: 'ECommerce',
    5: 'ECommerce',
};

const FEE_PROFILE_TYPES = {
    0: 'FlatRate',
    1: 'InterchangePlus',
};

const FEE_BILLING_TYPES = {
    0: 'Monthly',
    1: 'PerTransaction',
};

const PROCESSOR_FUNDING_PROGRAM_TYPES = {
    0: 'NextDay',
    1: 'SameDay',
};

const RETURN_TYPES = {
    0: 'NextDay',
    1: 'SameDay',
};

const TRANSACTION_STATUSES = {
    0: 'New',
    1: 'Submitted',
    2: 'Funded',
    3: 'AuthOnly',
    4: 'Rejected',
    5: 'Declined',
    6: 'Conveyed',
    7: 'Held',
    8: 'Captured',
    9: 'Processing',
    10: 'Incomplete',
};

// +--------------------+-----------------+
// |  Transaction Type  | Accounting Type |
// +--------------------+-----------------+
// | Deposit            | Credit          |
// | Refund             | Debit           |
// | Chargeback         | Debit           |
// | ACHFee             | Debit           |
// | ACHDeposit         | Credit          |
// | MonthlyFee         | Debit           |
// | ChargebackReversal | Credit          |
// | Decline            | Debit           |
// | AVSOnly            | Debit           |
// | Unknown            | ???             |
// | AdjustmentFrom     | Debit           |
// | AdjustmentTo       | Credit          |
// | ACHReturn          | Debit           |
// | Fee                | Debit           |
// +--------------------+-----------------+

const TRANSACTION_TYPES = {
    0: 'Deposit',
    1: 'Refund',
    2: 'Chargeback',
    3: 'ACHFee',
    4: 'ACHDeposit',
    5: 'MonthlyFee',
    6: 'ChargebackReversal',
    7: 'Decline',
    8: 'AVSOnly',
    9: 'Unknown',
    10: 'AdjustmentFrom',
    11: 'AdjustmentTo',
    12: 'ACHReturn',
    13: 'Fee',
};

const NETWORKS = {
    0: 'Unknown',
    1: 'Visa',
    2: 'MasterCard',
    3: 'AmericanExpress',
    4: 'Discover',
    5: 'JCB',
    6: 'Europay',
    7: 'PrivateLabel',
    8: 'PayPal',
    9: 'JackHenryACH',
    10: 'DinersClubInternational',
    11: 'Debit',
    12: 'ACH',
    13: 'ChinaUnionPay',
    14: 'Adjustment',
};

const DEPOSIT_TYPES = {
    0: 'Transactions',
    1: 'Fees',
    2: 'BankTransfers',
};

const DEPOSIT_STATUSES = {
    0: 'New',
    1: 'Submitted',
    2: 'Funded',
    3: 'PartiallyRejected',
    4: 'Rejected',
};

const ACCOUNT_STATUSES_ENUM = createEnum(ACCOUNT_STATUSES);
const CARD_TYPES_ENUM = createEnum(CARD_TYPES);
const CARD_PRESENT_TYPES_ENUM = createEnum(CARD_PRESENT_TYPES);
const DEPOSIT_STATUSES_ENUM = createEnum(DEPOSIT_STATUSES);
const DEPOSIT_TYPES_ENUM = createEnum(DEPOSIT_TYPES);
const FEE_BILLING_TYPES_ENUM = createEnum(FEE_BILLING_TYPES);
const FEE_PROFILE_TYPES_ENUM = createEnum(FEE_PROFILE_TYPES);
const NETWORKS_ENUM = createEnum(NETWORKS);
const PROCESSOR_FUNCING_PROGRAM_TYPES_ENUM = createEnum(PROCESSOR_FUNDING_PROGRAM_TYPES);
const RETURN_TYPES_ENUM = createEnum(RETURN_TYPES);
const TRANSACTION_STATUSES_ENUM = createEnum(TRANSACTION_STATUSES);
const TRANSACTION_TYPES_ENUM = createEnum(TRANSACTION_TYPES);

const getMultiplierByTransactionType = (transactionType) => {
    /*
        +--------------------+-----------------+
        |  Transaction Type  | Accounting Type |
        +--------------------+-----------------+
        | Deposit            | Credit          |
        | Refund             | Debit           |
        | Chargeback         | Debit           |
        | ACHFee             | Debit           |
        | ACHDeposit         | Credit          |
        | MonthlyFee         | Debit           |
        | ChargebackReversal | Credit          |
        | Decline            | Debit           |
        | AVSOnly            | Debit           |
        | Unknown            | ???             |
        | AdjustmentFrom     | Debit           |
        | AdjustmentTo       | Credit          |
        | ACHReturn          | Debit           |
        | Fee                | Debit           |
        +--------------------+-----------------+
     */

    switch (transactionType) {
        case TRANSACTION_TYPES_ENUM.Deposit:
        case TRANSACTION_TYPES_ENUM.ACHDeposit:
        case TRANSACTION_TYPES_ENUM.ChargebackReversal:
        case TRANSACTION_TYPES_ENUM.AdjustmentTo:
            return 1;

        case TRANSACTION_TYPES_ENUM.Refund:
        case TRANSACTION_TYPES_ENUM.Chargeback:
        case TRANSACTION_TYPES_ENUM.ACHFee:
        case TRANSACTION_TYPES_ENUM.MonthlyFee:
        case TRANSACTION_TYPES_ENUM.AdjustmentFrom:
        case TRANSACTION_TYPES_ENUM.AVSOnly:
        case TRANSACTION_TYPES_ENUM.Decline:
        case TRANSACTION_TYPES_ENUM.ACHReturn:
        case TRANSACTION_TYPES_ENUM.Fee:
            return -1;

        default:
            throw new Errors.BadArgumentsError('Encounterd a transaction type we did not expect', {
                transactionType,
            });
    }
};

module.exports = {
    // lookups (code => text)
    ACCOUNT_STATUSES,
    CARD_TYPES,
    CARD_PRESENT_TYPES,
    DEPOSIT_STATUSES,
    DEPOSIT_TYPES,
    FEE_BILLING_TYPES,
    FEE_PROFILE_TYPES,
    NETWORKS,
    PROCESSOR_FUNDING_PROGRAM_TYPES,
    RETURN_TYPES,
    TRANSACTION_STATUSES,
    TRANSACTION_TYPES,

    // enums (text => code)
    ACCOUNT_STATUSES_ENUM,
    CARD_TYPES_ENUM,
    CARD_PRESENT_TYPES_ENUM,
    DEPOSIT_STATUSES_ENUM,
    DEPOSIT_TYPES_ENUM,
    FEE_BILLING_TYPES_ENUM,
    FEE_PROFILE_TYPES_ENUM,
    NETWORKS_ENUM,
    PROCESSOR_FUNCING_PROGRAM_TYPES_ENUM,
    RETURN_TYPES_ENUM,
    TRANSACTION_STATUSES_ENUM,
    TRANSACTION_TYPES_ENUM,

    // utilities
    getMultiplierByTransactionType,
};
